<template>
  <div class="member">
    <Header></Header>
    <div class="member-top">
      <div class="member-info">
        <span class="avatar">
          <img src="../assets/avatar-default.png" />
        </span>
        <div class="member-text">
          <p>{{uname}}</p>
          <p>天道酬勤，坚持就是胜利，加油吧！</p>
        </div>
      </div>
    </div>

    <div class="member-body">
      <div class="member-sidebar">
        <h3 class="sidebar-title">
          <i></i>学习中心
        </h3>
        <ul class="sidebar-nav">
          <li class="selected">
            <i class="sidebar-line"></i>
            <a class="router-link-exact-active router-link-active" href="javascript:;">
              <i></i>我的课程
            </a>
          </li>
        </ul>
        <!-- <h3 class="sidebar-title">
          <i></i>个人中心
        </h3>
        <ul class="sidebar-nav">
          <li class="">
            <i class="sidebar-line"></i>
            <a class="" href="javascript:;">
              <i></i>账号管理
            </a>
          </li>
        </ul> -->
      </div>
      <div class="member-main">
        <div class="member-main-tab">
          <ul class="main-tab">
            <li class="active">所有课程({{youxiaoCount}})</li>
            <!-- <li class="active">已学课程({{yiyueCount}})</li> -->
          </ul>
        </div>
        <div class="member-main-body">
          <div v-for="(v, k) in list" :key="k">
            <div class="course-fa">{{v.title}}</div>
            <ul class="course-list">
              <li v-for="(item, index) in v.child" :key="index">
                <div class="course-name">{{item.title}}</div>
                <div class="course-btn">
                  <router-link
                    :to="{ name: 'Study', params: { cid: item.cid } }"
                    title="开始学习"
                  >
                    <el-button type="primary">开始学习</el-button>
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '../components/header.vue'
  import { getCourseList } from "../api/api";
  export default {
    name: 'Member',
    components: {
      Header
    },
    data() {
      return {
        youxiaoCount: 0,
        yiyueCount: 1,
        uname: '',
        list: []
      }
    },
    created() {
      var token = window.localStorage.getItem('jwt_token')
      if(!token){
        this.$router.push('/login')
      }
      var uname = window.localStorage.getItem('uname')
      this.uname = uname
      this.getCourseListx();
    },
    methods: {
      getCourseListx(){
        getCourseList({})
          .then(res => {
            if (res.code == 1) {
              let listx = res.data.course_list;
              this.list = listx;
              this.youxiaoCount = res.data.count;
            }else if(res.code == -2){
              // this.$Message.info('登陆超时，请重新登录');
              this.$router.push('/login')
            }
          })
          .catch(err => {

          });
      }
    }
  }
</script>

<style>
  .member-top {
    width: 100%;
    height: 318px;
    padding-top: 145px;
    background: url(../assets/member-banner.png) no-repeat top
  }

  .member-top .member-info {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto
  }
  .member-top .member-info .avatar{
    background: #fff;
    border-radius: 50%;
    overflow: hidden;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
  }
  .member-top .member-info .avatar img{
    width: 100px;
  }

  .member-top .member-info .member-text {
    flex: 1;
    margin-left: 20px;
    color: #fff
  }

  .member-top .member-info .member-text p:first-child {
    font-size: 22px
  }

  .member-top .member-info .member-integral {
    width: 130px
  }

  .member-body {
    width: 1200px;
    margin: 20px auto;
    display: flex;
    align-items: stretch
  }

  .member-sidebar {
    width: 200px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    border-radius: 6px
  }

  .member-sidebar .sidebar-title {
    padding: 18px 20px 12px 20px;
    font-size: 16px;
    border-bottom: 3px solid #f7f7f7;
    margin-bottom: 2px
  }

  .member-sidebar .sidebar-title i {
    display: inline-block;
    vertical-align: -.1em;
    width: 4px;
    height: 14px;
    background: linear-gradient(#2da6fe, #2680fa);
    margin-right: 10px;
    border-radius: 6px
  }

  .member-sidebar .sidebar-nav {
    width: 100%
  }

  .member-sidebar .sidebar-nav li {
    width: 200px;
    height: 50px;
    line-height: 50px;
    margin-bottom: 2px
  }

  .member-sidebar .sidebar-nav li .sidebar-line {
    display: inline-block;
    vertical-align: middle;
    width: 6px;
    height: 50px
  }

  .member-sidebar .sidebar-nav li a {
    margin-left: 10px;
    display: inline-block;
    vertical-align: middle;
    color: #868686;
    font-size: 16px
  }

  .member-sidebar .sidebar-nav li a i {
    width: 24px;
    height: 24px;
    padding: 3px
  }

  .member-sidebar .sidebar-nav li a span {
    vertical-align: -.1em;
    margin-left: 5px;
    margin-right: 15px
  }

  .member-sidebar .sidebar-nav li.selected,
  .member-sidebar .sidebar-nav li:hover {
    background: #eee
  }

  .member-sidebar .sidebar-nav li.selected a,
  .member-sidebar .sidebar-nav li:hover a {
    color: #41a1fc
  }

  .member-sidebar .sidebar-nav li:hover .sidebar-line {
    background: #eee
  }

  .member-sidebar .sidebar-nav li.selected .sidebar-line {
    background: linear-gradient(#2da6fe, #2680fa)
  }

  .member-main {
    margin-left: 30px;
    width: 970px
  }

  .member-main-tab {
    width: 100%;
    height: 60px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 20px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    display: flex
  }

  .member-main-tab .main-tab {
    flex: 1;
    padding: 10px 20px;
    display: flex
  }

  .member-main-tab .main-tab li {
    position: relative;
    height: 40px;
    line-height: 40px;
    cursor: pointer;
    color: #666;
    padding: 0 10px;
    margin-right: 40px
  }

  .member-main-tab .main-tab li:hover {
    color: #333
  }

  .member-main-tab .main-tab li.active {
    font-weight: 700;
    color: #333
  }

  .member-main-tab .main-tab li.active:after {
    position: absolute;
    content: " ";
    color: #fff;
    background: linear-gradient(90deg, #27a3ff, #2380fb);
    width: 20px;
    height: 4px;
    border-radius: 10px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%)
  }

  .member-main-body {
    position: relative;
    width: 100%;
    background: #fff;
    border-radius: 6px;
    min-height: 560px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1)
  }

  .member-main-body .main-header {
    width: 100%;
    background: #f5f5f5;
    height: 60px;
    padding: 0 30px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px
  }

  .member-main-body .no-data {
    padding-top: 100px;
    text-align: center
  }

  .member-main-body .no-data img {
    margin: 0 auto
  }

  .member-main-body .no-data p {
    font-size: 16px;
    color: #666
  }

  .member-main-body .main-table {
    position: relative;
    width: 100%;
    padding: 0 30px
  }

  .member-main-body .main-table.scroll-top {
    margin-top: -60px
  }

  .member-main-body .main-table table {
    width: 100%
  }

  .member-main-body .main-table table thead th {
    height: 60px;
    color: #999
  }

  .member-main-body .main-table table td,
  .member-main-body .main-table table th {
    text-align: left
  }

  .member-main-body .main-table table td.center,
  .member-main-body .main-table table th.center {
    text-align: center
  }

  .member-main-body .main-table table td.right,
  .member-main-body .main-table table th.right {
    text-align: right
  }

  .member-main-body .main-table table td {
    padding: 12px 0;
    border-bottom: 1px dashed #ccc;
    line-height: 20px;
    color: #666
  }

  .member-main-body .main-table table td .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden
  }

  .course-search {
    margin: 14px 30px 0 0
  }

  .course-search .ivu-input {
    background: #f2f2f2;
    border-radius: 20px;
    padding-left: 12px
  }

  .course-list {
    padding: 20px 30px
  }

  .course-list li {
    border-bottom: 1px dashed #ccc;
    display: flex;
    align-items: center;
    padding: 10px 0
  }

  .course-list li .course-name {
    flex: 1;
    font-size: 16px
  }

  .course-list li .course-btn {
    width: 100px
  }

  .course-fa{
    padding: 20px 20px 0 20px;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/pages/member.vue